import { DatetimePickerField } from '@monorepo/shared/componentsV2/fields/DatetimePickerField';
import { StyledFormGroup } from '@monorepo/shared/componentsV2/styled/form';
import { isRequired } from '@monorepo/shared/utils/validators';
import { DateLike, localEquivalentOfUTC } from 'mapistry-shared';
import React, { useMemo } from 'react';
import { LOG_DATE_FIELD_NAME, LogEntry } from '../types';

type EditLogEntryBuiltInFieldsProp = {
  existingLogEntry?: LogEntry;
  initialLogDate?: DateLike;
  fieldNamePrefix?: string;
  disabled?: boolean;
  className?: string;
  isLabelHidden?: boolean;
  isCompact?: boolean;
  isErrorTextHidden?: boolean;
  forceShowErrors?: boolean;
};

export function EditLogEntryBuiltInFields({
  existingLogEntry,
  initialLogDate,
  fieldNamePrefix,
  disabled,
  className,
  isLabelHidden,
  isCompact,
  isErrorTextHidden,
  forceShowErrors,
}: EditLogEntryBuiltInFieldsProp) {
  const initialLogDateValue = useMemo(() => {
    let value = new Date();
    if (existingLogEntry?.logDate) {
      value = localEquivalentOfUTC(new Date(existingLogEntry.logDate));
    } else if (initialLogDate) {
      value = new Date(initialLogDate);
    }
    return value;
  }, [existingLogEntry?.logDate, initialLogDate]);

  return (
    <StyledFormGroup row className={className}>
      <DatetimePickerField
        disabled={disabled}
        subText=""
        label="Log Date"
        name={
          fieldNamePrefix
            ? `${fieldNamePrefix}.${LOG_DATE_FIELD_NAME}`
            : LOG_DATE_FIELD_NAME
        }
        initialValue={initialLogDateValue}
        validate={isRequired}
        required
        isLabelHidden={isLabelHidden}
        isCompact={isCompact}
        isErrorTextHidden={isErrorTextHidden}
        forceShowErrors={forceShowErrors}
      />
    </StyledFormGroup>
  );
}
